module.exports = __webpack_public_path__ + "static/media/PATS_1-139w.ffd0380d.png";